import { core } from '@tock/coretypes';
import { currentMetroAreaSelector } from 'selectors/metroAreaSelectors';
import { useDeepMemo } from 'hooks/useDeepMemo';
import { useSelector } from 'react-redux';

/**
 * convenience hook for getting the current metro area
 * uses the correct selector, etc.
 */
export function useCurrentMetroArea(): core.MetroArea | undefined {
  const currentMetroArea = useSelector(currentMetroAreaSelector);
  const currentMetroMemo = useDeepMemo(() => currentMetroArea, [currentMetroArea]);
  return currentMetroMemo;
}
